export default __webpack_public_path__ + "images/dcd90bcc-build-min.png";